import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Dictionary } from "src/app/store/models/common_types";
import { Router } from "@angular/router";
import {
  VAIconRegistryService,
  comment,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-notes-section",
  templateUrl: "./notes-section.component.html",
  styleUrls: ["./notes-section.component.scss"],
})
export class NotesSectionComponent implements OnInit {
  @Input() notesData: Dictionary<any>;
  @Input() ticker: string;
  usersnapJsKey: any;
  snapEmail: any;
  userName: any;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([comment, exclamationTriangle]);
  }
  ngOnInit() {
    this.notesData = {
      data: [],
      isLoading: true,
    };
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.notesData &&
      changes.notesData.previousValue !== this.notesData
    ) {
      this.notesData = changes.notesData.currentValue;
    }
  }
  redirect(url) {
    //window.location.href = url;
    this.router.navigateByUrl(url);
  }
  redirectToNote(functionType, tabName, datapointId, period, basis) {
    const noteUrl = `/mex/${this.ticker}/NMV/${tabName}`,
      today = new Date(),
      date = today.getDate().toString().padStart(2, "0"),
      month = (today.getMonth() + 1).toString().padStart(2, "0"),
      year = today.getFullYear(),
      finalDpIdDate = `${month}/${date}/${year}`,
      actualdatapointId = `${datapointId}|${finalDpIdDate}`;

    if (functionType === "notLineItem") {
      this.redirect(
        `${noteUrl}?dpid=${actualdatapointId}&basis=${basis}&period=${period}&expand_consensus=true`,
      );
    } else if (functionType === "LineItem") {
      this.redirect(`${noteUrl}?dpid=${datapointId}&basis=${basis}`);
    }
  }
  noteFeedback(noteId, noteType, text, tabfullname, parentRowIndex, rowIndex) {
    if (this.usersnapJsKey && this.usersnapJsKey !== "") {
      window.Usersnap.init({
        button: { isHidden: true },
      });
      window.Usersnap.on("open", (event) => {
        event.api.setValue("custom", {
          email: `##${this.snapEmail}##`,
          username: this.userName,
          noteId: [noteId],
          noteType: [noteType],
          noteText: [text],
          tab: [tabfullname],
          ticker: this.ticker,
          label: "[4th Quad Analyst Dashboard]",
        });
        event.api.setValue("email", this.snapEmail);
        event.api.setValue("comment", "");
        this.notesData.data[parentRowIndex].value[rowIndex].isCommentActive =
          true;
      });
      window.Usersnap.on("close", () => {
        this.notesData.data[parentRowIndex].value[rowIndex].isCommentActive =
          false;
      });
      window.Usersnap.on("submit", () => {
        this.notesData.data[parentRowIndex].value[rowIndex].isCommentActive =
          false;
      });
      setTimeout(() => {
        window.Usersnap.open();
      }, 1000);
    }
  }
}
